import Vue from 'vue';
import merge from 'deepmerge';
import qs from 'qs';

let baseUrl = '';
let imagesSubPath = '';

const explorer = {
    semaphore: false,
    semaphorePromise: null,
    getBaseUrl: () => baseUrl,
    getImagesPath: () => baseUrl + '/' + imagesSubPath,
    makeRequest(url, method = 'GET', options = {}, omitAuthHeader = false) {
        let requestOptions = {
            method,
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {},
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *client
        };

        requestOptions.headers.Accept = 'application/json';

        if (options.body) {
            requestOptions.body = JSON.stringify(options.body);
            delete options.body;
            requestOptions.headers['Content-Type'] = 'application/json';
        }

        const accessToken = Vue.$store.state.user.accessToken;
        if (accessToken && !omitAuthHeader) {
            requestOptions.headers.authorization = `Bearer ${accessToken}`;
        }

        if (options.params) {
            Object.keys(options.params).forEach(key => {
                if (Array.isArray(options.params[key])) {
                    try {
                        options.params[key] = JSON.stringify(options.params[key]);
                    } catch {

                    }
                }
            });
        }

        let signal;
        if (options.signal) {
            signal = options.signal;
            delete options.signal;
        }

        let path = new URL(`${baseUrl}${url}?${qs.stringify(options.params)}`);

        const mergedRequestOptions = merge(requestOptions, options);
        if (signal) {
            mergedRequestOptions.signal = signal;
        }

        return new Promise((resolve, reject) => {
            if (!this.semaphore || omitAuthHeader) {
                fetch(path, mergedRequestOptions)
                    .then(response => {
                        if (!response.ok) {
                            if (response.status === 401 && accessToken) {
                                if (!this.semaphore) {
                                    this.semaphore = true;
                                    this.semaphorePromise = Vue.$auth.refreshToken().then(refreshResult => {
                                        this.semaphore = false;
                                        return refreshResult;
                                    });
                                    this.resendRequest(url, method, mergedRequestOptions, resolve, reject);
                                } else {
                                    this.resendRequest(url, method, mergedRequestOptions, resolve, reject);
                                }
                            } else {
                                return response.json().then(err => {
                                    reject(err);
                                });
                            }
                        } else {
                            if (response.status === 204) {
                                resolve(response);
                            } else {
                                return response
                                    .json()
                                    .then(data => this.extractEmbedded(data))
                                    .then(data => resolve(data));
                            }
                        }
                    })
                    .catch(err => {
                        reject(err);
                    });
            } else {
                this.resendRequest(url, method, mergedRequestOptions, resolve, reject);
            }
        });
    },
    resendRequest(url, method, mergedRequestOptions, resolve, reject) {
        this.semaphorePromise.then(refreshResult => {
            if (refreshResult) {
                delete mergedRequestOptions.headers.authorization;
                this.makeRequest(url, method, mergedRequestOptions).then(response => {
                    resolve(response);
                });
            } else {
                reject();
            }
            return refreshResult;
        });
    },
    extractEmbedded(data) {
        if (data._embedded && typeof data._embedded === 'object') {
            for (const prop of Object.keys(data._embedded)) {
                data[prop] = this.extractEmbedded(data._embedded[prop]);
            }

            delete data._embedded;
        } else if (typeof data !== 'string' && data.length) {
            data.forEach((element, index) => {
                data[index] = this.extractEmbedded(element);
            });
        }

        return data;
    },
};

export default {
    install(Vue, options) {
        baseUrl = options.baseUrl;
        imagesSubPath = options.imagesSubPath;

        Vue.$explorer = explorer;
        Vue.prototype.$explorer = explorer;
    },
};
